// src/pages/CourseTime/components/slides/layouts/ContentPointsListSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';

// Layouts: Introduction_title_with_goals, content_3_points_with_no_image,
// content_4_points_with_no_image
const ContentPointsListSlide = ({ slide, renderSpokenText, skipTitleSpeech }) => {
  const { renderContent } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  return (
    <S.SlidePoints>
      {Array.isArray(slide.SlideContent) && slide.SlideContent.map((point, idx) => (
          <S.SlidePoint key={idx}>
            {typeof point === 'string' ? (
                <S.PointText>{renderContent(`content_${idx}`, point)}</S.PointText>
            ) : (
                <>
                  {point.PointTitle && <S.PointTitle>{renderContent(`content_${idx}_title`, point.PointTitle)}</S.PointTitle>}
                  {point.PointText  && <S.PointText>{renderContent(`content_${idx}_text`,  point.PointText)}</S.PointText>}
                </>
            )}
          </S.SlidePoint>
      ))}
      {typeof slide.SlideContent === 'string' && (
          <S.SlidePoint>
            <S.PointText>{renderContent('content_0', slide.SlideContent)}</S.PointText>
          </S.SlidePoint>
      )}
    </S.SlidePoints>
  );
};

export default ContentPointsListSlide;
